(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairRatingCommentsController",
      VirtualFairRatingCommentsController
    );
    VirtualFairRatingCommentsController.$inject = [
    "VirtualFairService",
    "$timeout",
    "$uibModal",
    "cyberSessions"
  ];

  function VirtualFairRatingCommentsController(
    VirtualFairService,
    $timeout,
    $uibModal,
    cyberSessions
  ) {
    var vm = this;
    vm.getVirtualFairs = getVirtualFairs;
    vm.getByFilter = getByFilter;
    vm.queryFlag = false;
    vm.virtualFairSelected = "";
    vm.virtualFairsData = [];
    vm.synchronizeAfterUpdate = synchronizeAfterUpdate;
    vm.cyberSessions = cyberSessions;
    vm.transformData = transformData;
    vm.students = students;

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter(false);
    }

    function getVirtualFairs() {
      vm.query = {};
      vm.query = {'upcoming': 1};
      VirtualFairService.getAll(vm.query).then(function (response) {
        vm.virtualFairs = response.data;
        vm.virtualFairs.unshift({
          id: -1,
          name: '-- ALL --'
        });
        vm.virtualFairSelected = -1;
      });
    }

    async function getByFilter() {
      vm.queryFlag = false;
      vm.query = {};
      vm.query["page"] = vm.page;
      vm.cyberSessionsData = [];
      if (vm.virtualFairSelected) {
        vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      }
      VirtualFairService.getRatingComments(vm.query, true)
      .then(async function (response) {
        // vm.queryFlag = true;
        // console.log(response.data);
        // //vm.cyberSessionsData = transformData(response.data);
        // vm.cyberSessionsData = response.data;
        var rawData = response.data;
    
      vm.cyberSessionsData = await Object.keys(rawData).map(function(universityName) {
        return {
            name: universityName,
            rooms: Object.keys(rawData[universityName]).map(function(roomName) {
              console.log( rawData[universityName][roomName])
                return {
                    name: roomName,
                    sessions: rawData[universityName][roomName],
                };
            })
        };
      });
      
      console.log(vm.cyberSessionsData);
        vm.to = response.data.to;
        vm.totalItems = response.data.total;
        vm.itemsPerPage = response.data.per_page;
        vm.setPage(response.data.current_page);
      });
    }

    function transformData(data) {
      let resultArray = [];
  
      for (let name in data) {
          let rooms = data[name];
          for (let room in rooms) {
              let sessions = rooms[room];
              for (let time in sessions) {
                  resultArray.push({
                      name: name,
                      room: room,
                      timeStart: time,
                      totalBooked: sessions[time],

                  });
              }
          }
      }
  
      return resultArray;
    }

    function students(id) {
      $uibModal.open({
          templateUrl: 'templates/virtualfairs/rating-comments/students/template.modal.html',
          controller: 'VirtualFairCyberSessionStudentsController',
          controllerAs:'vm',
          resolve:
          {
              students : function () {
                return VirtualFairService.getRatingCommentsDetails(id)
                  .then(response => response.data)
              },
          }
      }).result.then(function(result) {
        vm.synchronizeAfterUpdate(result);
      }).catch(function(reason) {
        console.log(reason);
        throw reason;
      });
    }

    function synchronizeAfterUpdate(updatedItem) {
      if(updatedItem) {
        vm.virtualFairsData = vm.virtualFairsData.map((virtualFair) => {
          if(virtualFair.id == updatedItem.id) {
            virtualFair.platform_fair_id = updatedItem.platform_fair_id;
            virtualFair.platform_fair_code = updatedItem.platform_fair_code;
            virtualFair.platform_prefix = updatedItem.platform_prefix;
          }
          return virtualFair;
        });
      }
    }

    function active() {
      vm.getVirtualFairs();
    }

    active();
  }
})();
